export default __webpack_public_path__ + "static/media/wordmark.8fdd0452.png";